<template>
  <div id="consulta-por-cpf-para-mcmv-cidades" class="consulta-por-cpf column">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
     <div class="formulario u-margem-pequena">
        <h2 class="titulo titulo_grande u-margem-esquerda-pequena">
          Informe o CPF do pretendente para solicitar o subsídio para o projeto
          {{ projeto.Nome }}
        </h2>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <alerta
              v-if="deveExibirAlerta"
              :tipo="tipoDeAlerta"
              :texto="mensagemDeAlerta"
            />
          </div>
        </div>
        <div class="grade__linha grade__linha_alinhar-vertical-a-base">
          <div class="formulario">
            <div class="grade__linha">
              <div class="grade__coluna campos-numericos-medio">
                <label class="formulario__label" for="cpf">CPF</label>
                <input
                  id="cpf"
                  type="text"
                  placeholder="Insira somente números do CPF"
                  v-model="cpf"
                  v-mask="'999.999.999-99'"
                />
              </div>
              <div
                class="grade__coluna grade__coluna_4 u-margem-superior-grande"
              >
                <button
                  v-if="true"
                  type="button"
                  @click="obterProtocoloPorCpf"
                  class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio u-sem-margem-superior"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                  Adicionar
                </button>
              </div>
            </div>
            <div class="grade__linha">
              <div class="grade__coluna grade__coluna_5">
                <h5
                  class="titulo titulo_cor-terciaria"
                  v-for="proponente in proponentes"
                >
                  {{ proponente.Nome }}
                  {{ proponente.Conjuge ? `, ${proponente.Conjuge.Nome}` : "" }}
                  <button
                    v-if="true"
                    type="button"
                    @click="removerProponente(proponente)"
                    class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio"
                  >
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </h5>
              </div>
            </div>
          </div>
        </div>

        <div class="grade__linha grade__linha_alinhar-vertical-a-base">
          <div class="grade__coluna campos-numericos-medio">
            <label class="formulario__label" for="renda-familiar-comprovada"
              >Renda Familiar comprovada</label
            >
            <input
              name="renda-familiar-comprovada"
              type="text"
              id="renda-familiar-comprovada"
              class="formulario__input u-margem-inferior-pequena"
              placeholder="Insira a renda familiar"
              v-model="
                dadosParaValidacaoDaRendaFamiliarComprovada.RendaFamiliar
              "
              v-mask="'money'"
              required
            />
            <button
              type="button"
              class="botao botao_medio botao_cinza u-margem-direita-media"
              @click="retornarParaSelecaoDeProjetos"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="botao botao_medio botao_cor-terciaria u-margem-superior-media"
              :class="{ 'is-loading': loading }"
              :disabled="!preencheuRenda || !possuiProponentes"
              @click="validarRendaFamiliarComprovada"
            >
              Avançar
            </button>
          </div>
        </div>
      </div>
    </div>
    <MensagemFlutuante
      :mensagemVisivel="mensagemFlutuante.mensagemVisivel"
      :titulo="mensagemFlutuante.tituloMensagem"
      :estilo="mensagemFlutuante.estiloMensagem"
      :texto="mensagemFlutuante.textoMensagem"
      @close="fecharMensagem"
    />
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Loading from "../../shared/Loading";
import Alerta from "../../shared/Alerta";
import MensagemFlutuante from "../../shared/MensagemFlutuante";

export default {
  name: "consulta-por-cpf-para-mcmv-cidades",
  components: { Loading, Alerta, MensagemFlutuante },

  data() {
    return {
      proponentes: [],
      cpf: null,
      loading: false,
      linkDoInscricao: false,
      textoDoAlerta: null,
      tipoDoAlerta: null,
      urlInscricaoCompartilhada: process.env.URL_INSCRICAO_COMPARTILHADA,
      projetos: this.projetos || [],
      projeto: {},
      dadosParaValidacaoDaRendaFamiliarComprovada: {},
      tipoDeAlerta: null,
      mensagemDeAlerta: null,
      deveExibirAlerta: null,
      loading: {
        visivel: false,
      },
      podeAvancar: false,
      informouRendaValida: false,
      mensagemFlutuante: {
        mensagemVisivel: false,
        tituloMensagem: "",
        estiloMensagem: "",
        textoMensagem: "",
      },
    };
  },
  created() {
    this.projeto = JSON.parse(localStorage.getItem("projeto"));
  },
  directives: { mask: AwesomeMask },
  computed: {
    possuiProponentes() {
      return this.proponentes.length > 0;
    },
    preencheuRenda() {
      return (
        parseFloat(
          this.dadosParaValidacaoDaRendaFamiliarComprovada.RendaFamiliar
        ) > 0
      );
    },
  },
  methods: {
    obterProjetos() {
      this.exibirCarregamento();
      this.$api
        .get("/Projeto/ObterVigentes")
        .then((response) => {
          this.esconderCarregamento();
          let projetoPadrao = this.criarProjetoPadrao();
          this.projeto = projetoPadrao;
          this.projetos = [projetoPadrao];
          this.projetos = this.projetos.concat(response.data);
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    obterProtocoloPorCpf() {
      this.ocultarAlerta();
      const proponenteJaFoiAdicionado = this.proponentes.some(
        (p) => p.Cpf === this.cpf
      );
      if (!this.cpf || proponenteJaFoiAdicionado) {
        this.cpf = null;
        return;
      }
      this.exibirCarregamento();
      let dadosParaConsultaDoSolicitanteDto = {
        Cpf: this.cpf,
        ProjetoId: this.projeto.Id,
      };
      this.$api
        .post(
          "/solicitante/McmvCidades/ObterSituacaoDoProponente",
          dadosParaConsultaDoSolicitanteDto
        )
        .then((resultado) => {
          this.esconderCarregamento();

          if (proponenteJaFoiAdicionado) return;

          const dto = resultado.data;
          if (dto === null || dto.Protocolo === null) {
            this.exibirMensagemDeProponenteSemInscricao();
            return;
          }

          if (
            dto.Protocolo !== null &&
            !dto.CidadeDoProtocoloPossuiEmendaCadastrada
          ) {
            this.exibirMensagemDeCidadeSemEmendaCadastrada();
            return;
          }

          if (
            dto.Protocolo.EstaContemplado &&
            !dto.Protocolo.InformacoesDaFamilia.TemInteresseNoEmendasCidades
          ) {
            this.exibirMensagemDeProponenteJaContempladoSemInteresseNoEmendasCidades();
            return;
          }
          if (dto.ContemplacaoDeSubsidio !== null) {
            this.exibirMensagemDeProponenteBeneficiadoPorOutroSubsidio();
            return;
          }

          if (
            !dto.Protocolo.InformacoesDaFamilia.TemInteresseNoEmendasCidades
          ) {
            this.exibirMensagemDeProponenteQueNaoDemonstrouInteresseNoEmendasCidades();
            return;
          }

          this.adicionarProponente(dto);
          this.cpf = null;
          return;
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    adicionarProponente(dto) {
      const protocolo = dto.Protocolo;
      const cidadesDoProponente = this.agruparPorCidade();
      var todosOsProponentesSaoDaMesmaCidade =
        this.proponentes.length == 0 ||
        (parseInt(cidadesDoProponente[0]) == protocolo.IdCidade &&
          cidadesDoProponente.length == 1);
      if (todosOsProponentesSaoDaMesmaCidade) {
        const titular = protocolo.Titular;
        const proponente = {
          Nome: titular.Nome,
          Cpf: this.formatarCPF(titular.Cpf),
          Renda: titular.ValorDaRenda,
          Telefone: titular.Telefone,
          DataDeNascimento: titular.DataDeNascimento,
          Cidade: protocolo.Cidade,
          CidadeId: protocolo.IdCidade,
          EhMulherVitimaDeViolenciaDomestica:
            titular.EhMulherVitimaDeViolenciaDomestica,
          EhMulherChefeDeFamilia: titular.MulherChefeDeFamilia,
          EhIdoso: titular.EhIdoso,
          EhPessoaComDeficiencia: titular.EhPessoaComDeficiencia,
          EhIndigena: titular.EhIndigena,
          EhQuilombola: titular.FamiliaQuilombola,
          EhNegroOuPardo: titular.EhNegroOuPardo,
          PossuiOnusExcessivoComAluguel: titular.PossuiOnusExcessivoComAluguel,
          PossuiFamiliaEmCoabitacao: titular.PossuiFamiliaEmCoabitacao,
          Conjuge: null,
        };

        if (protocolo.Conjuge) {
          const conjuge = {
            Nome: protocolo.Conjuge.Nome,
            Cpf: this.formatarCPF(protocolo.Conjuge.Cpf),
            Renda: protocolo.Conjuge.ValorDaRenda,
            Telefone: protocolo.Conjuge.Telefone,
            DataDeNascimento: protocolo.Conjuge.DataDeNascimento,
            Cidade: protocolo.Cidade,
            CidadeId: protocolo.IdCidade,
            EhMulherVitimaDeViolenciaDomestica:
              protocolo.Conjuge.EhMulherVitimaDeViolenciaDomestica,
            EhMulherChefeDeFamilia: protocolo.Conjuge.MulherChefeDeFamilia,
            EhIdoso: protocolo.Conjuge.EhIdoso,
            EhPessoaComDeficiencia: protocolo.Conjuge.EhPessoaComDeficiencia,
            EhIndigena: protocolo.Conjuge.EhIndigena,
            EhQuilombola: protocolo.Conjuge.FamiliaQuilombola,
            EhNegroOuPardo: protocolo.Conjuge.EhNegroOuPardo,
            PossuiOnusExcessivoComAluguel:
              protocolo.Conjuge.PossuiOnusExcessivoComAluguel,
            PossuiFamiliaEmCoabitacao: protocolo.Conjuge.PossuiFamiliaEmCoabitacao,
          };
          proponente.Conjuge = conjuge;
        }
        this.proponentes.push(proponente);
        this.$localStorage.atribuir("proponentes", this.proponentes);
      } else {
        this.exibirMensagemDeErro(
          "Todos os proponentes devem ser da mesma cidade"
        );
      }
    },
    removerProponente(proponente) {
      var index = this.proponentes.indexOf[proponente];
      this.proponentes.splice(index, 1);
    },
    avancar() {
      this.redirecionarParaFormularioDeSolicitacao();
    },
    validarRendaFamiliarComprovada() {
      let dto = JSON.parse(
        JSON.stringify(this.$data.dadosParaValidacaoDaRendaFamiliarComprovada)
      );
      let valorInvalido =
        Object.keys(dto).length === 0 ||
        this.$moeda.removerFormatacao(dto.RendaFamiliar) === 0;

      if (valorInvalido) {
        this.exibirMensagemDeAtencao(
          "Verifique o campo preenchido e insira o valor da renda familiar corretamente"
        );
        return;
      }

      this.$localStorage.atribuir("rendaFamiliarComprovada", dto.RendaFamiliar);
      this.redirecionarParaFormularioDeSolicitacao(this.projeto.Id);
    },
    redirecionarParaFormularioDeSolicitacao(projetoId) {
      this.$router.push({
        name: "FormularioDeSolicitacaoParaMcmvCidades",
        params: { projetoId: projetoId },
      });
    },
    tratarErro(error) {
      this.esconderCarregamento();
      let mensagensDeErro = error.response.data.Message;
      this.exibirMensagemDeErro(mensagensDeErro);
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    ocultarAlerta() {
      this.textoDoAlerta = null;
      this.mensagemDeAlerta = null;
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    retornarParaSelecaoDeProjetos() {
      this.deveExibirFormularioParaRendaFamiliarComprovada = false;
      this.mensagemDeAlerta = null;
      this.cpf = null;
      this.limparProjetoSelecionado();
      this.definirProjetoPadrao();
      this.$router.push({ name: "SelecaoDeProjetoDeSubsidio" });
    },
    definirProjetoPadrao() {
      let projetoPadrao = this.criarProjetoPadrao();
      this.projeto = projetoPadrao;
    },
    criarProjetoPadrao() {
      return {
        Id: null,
        Nome: "Selecione o projeto",
        DeveComprovarRendaFamiliar: false,
      };
    },
    limparProjetoSelecionado() {
      this.projeto = {};
    },
    exibirAlerta(mensagem, tipo) {
      this.deveExibirAlerta = true;
      this.tipoDeAlerta = tipo || "erro";
      this.mensagemDeAlerta =
        mensagem ||
        "Ocorreu um erro interno. Tente novamente ou contate o suporte";
    },
    exibirMensagemDeErro(mensagem) {
      let estiloDaMensagem = "erro";
      this.exibirMensagem(mensagem, estiloDaMensagem);
    },
    exibirMensagemDeAtencao(mensagem) {
      let estiloDaMensagem = "atencao";
      this.exibirMensagem(mensagem, estiloDaMensagem);
    },
    exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
      this.mensagemFlutuante = {
        mensagemVisivel: true,
        tituloMensagem: tituloDaMensagem || "",
        estiloMensagem: estiloDaMensagem,
        textoMensagem: mensagem,
      };

      setTimeout(() => {
        this.fecharMensagem();
      }, 10000);
    },
    fecharMensagem() {
      this.mensagemFlutuante.mensagemVisivel = false;
    },
    agruparPorCidade() {
      const itensAgrupados = this.proponentes.reduce(
        (groups, item) => ({
          ...groups,
          [item.CidadeId]: [...(groups[item.CidadeId] || []), item],
        }),
        {}
      );
      return Object.keys(itensAgrupados);
    },
    exibirMensagemDeProponenteQueNaoDemonstrouInteresseNoEmendasCidades() {
      const mensagem = `É necessário que o solicitante demonstre interesse no projeto emendas cidades no <a href="${this.urlInscricaoCompartilhada}" target='blank'> sistema de inscricao da AGEHAB.</a>`;
      this.exibirAlerta(mensagem, "atencao");
    },
    exibirMensagemDeProponenteBeneficiadoPorOutroSubsidio() {
      const mensagem =
        "Essa inscrição já foi contemplada e foi beneficiada por outro projeto de subsídio. Por favor, consulte a AGEHAB para obter mais informações.";
      this.exibirMensagemDeErro(mensagem);
    },
    exibirMensagemDeProponenteJaContempladoSemInteresseNoEmendasCidades() {
      const mensagem = `Essa inscrição não demonstrou interesse no projeto Emendas Cidades e já foi contemplada. Para mais informações busque atendimento: <br/> <ul><li>Campo Grande/MS: Procure um <strong>Fácil</strong> ou para mais informações, ligue para <strong> 0800-647-3120</strong></li><li>Demais cidades: procure a <strong>Prefeitura Municipal</strong></li></ul>`;
      this.exibirMensagemDeErro(mensagem);
    },
    exibirMensagemDeProponenteSemInscricao() {
      const mensagem = `É necessário que o solicitante esteja cadastrado no <a href="${this.urlInscricaoCompartilhada}" target='blank'> sistema de inscricao da AGEHAB.</a>`;
      this.exibirAlerta(mensagem, "atencao");
    },
    exibirMensagemDeCidadeSemEmendaCadastrada() {
      const mensagem = `Não há emendas cadastradas para a cidade da inscrição. Por favor, consulte a AGEHAB para mais informações`;
      this.exibirMensagemDeErro(mensagem);
    },
    formatarCPF(cpf) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConsultaPorCpfParaMcmvCidades.vue?0d5be115